export default __webpack_public_path__ + "static/arindamLehri14-7beec8792d71391303d15324e9c498a4.jpg";